import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SoftwareElectronicsService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient) { }

  public getDropDown(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }

  public getSalesBridgeValues(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }

  public getMarginBrigeValues(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }

  public getAlgorithmsValues(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }

  public getCustomerByTrendBridgeValues(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }

  public getTop5Values(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
}
